import React from 'react';
import { Section, Field } from './ui/formkit';

function ClientInfo({ client, handleChange }) {
  return (
    <div>
      <Section title="Client" description="Name and operational status.">
        <Field label="Client name" span={2} required>
          <input type="text" name="name" value={client.name || ''} onChange={handleChange} placeholder="e.g. Contoso Ltd" required />
        </Field>
        <Field label="Status">
          <select name="status" value={client.status || ''} onChange={handleChange}>
            <option value="">Select status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
            <option value="Onboarding">Onboarding</option>
          </select>
        </Field>
        <Field label="Start date">
          <input type="date" name="startDate" value={client.startDate || ''} onChange={handleChange} />
        </Field>
      </Section>

      <Section title="Billing">
        <Field label="Invoiced">
          <select name="invoiced" value={client.invoiced ? 'true' : 'false'} onChange={handleChange}>
            <option value="false">No</option>
            <option value="true">Yes</option>
          </select>
        </Field>
        <Field label="Access code" hint="Guests use this code on the timesheet entry page.">
          <input type="text" name="accessCode" value={client.accessCode || ''} onChange={handleChange} placeholder="Optional" />
        </Field>
      </Section>
    </div>
  );
}

export default ClientInfo;
